import Error from "./components/Error";
import { Toaster } from "react-hot-toast";
import Trips from "./components/Trips/Trips";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {  
  return (
    <Router>
      <Toaster containerStyle={{ zIndex: "99999999" }} />
      <Routes>
        <Route path=":ref" element={<Trips />} />
        <Route path="*" element={<Error />} />
      </Routes>
      {/* <p className="text-end font-Neue text-xs mt-[-16px] mr-3 font-bold text-[#6c757d] py-2 md:py-0">
        powered by SijuByTruQ
      </p> */}

      <a
        href="https://wa.me/+2348144968867"
        className="fixed flex bottom-4 right-4 z-50 bg-[#25D366] py-1 px-2 text-white text-sm rounded-full shadow-lg hover:bg-[#128C7E] transition-all duration-300"
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="35"
          height="35"
          viewBox="0 0 24 24"
          fill="white"
        >
          <path d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.38 2.27 1.019 3.287l-.582 2.128 2.182-.573c.978.58 1.911.928 3.145.929 3.178 0 5.767-2.587 5.768-5.766.001-3.187-2.575-5.771-5.764-5.771zm3.392 8.244c-.144.405-.837.774-1.17.824-.299.045-.677.063-1.092-.069-.252-.08-.575-.187-.988-.365-1.739-.751-2.874-2.502-2.961-2.617-.087-.116-.708-.94-.708-1.793s.448-1.273.607-1.446c.159-.173.346-.217.462-.217l.332.006c.106.005.249-.04.39.298.144.347.491 1.2.534 1.287.043.087.072.188.014.304-.058.116-.087.188-.173.289l-.26.304c-.087.086-.177.18-.076.354.101.174.449.741.964 1.201.662.591 1.221.774 1.394.86s.274.072.376-.043c.101-.116.433-.506.549-.68.116-.173.231-.145.39-.087s1.011.477 1.184.564.289.13.332.202c.045.072.045.419-.1.824z"/>
        </svg>
        <span className="hidden md:block md:my-auto">Chat with us on WhatsApp</span>
      </a>
    </Router>
  );
}

export default App;
